"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableSelectionManager = void 0;
var STATES = {
    DEFAULT: "default",
    SELECTED: "selected cells",
};
var MOUSE_EVENTS = {
    MOVE: "mousemove",
    DOWN: "mousedown",
    UP: "mouseup",
    LEAVE: "mouseleave",
};
var TableSelectionManager = (function () {
    function TableSelectionManager(tableProps, setSelection) {
        var _this = this;
        this.elementToIndex = new Map();
        this.clearCellElem = function (elem) {
            _this.elementToIndex.delete(elem);
        };
        this.setSelection = setSelection;
        this.tableProps = tableProps;
        this.onEvent = this.onEvent.bind(this);
        this.deselect = this.deselect.bind(this);
        this.selectAllCells = this.selectAllCells.bind(this);
        this.moveToSelectedState = this.moveToSelectedState.bind(this);
    }
    TableSelectionManager.prototype.setCellElem = function (cellIndex, elem) {
        this.elementToIndex.set(elem, cellIndex);
    };
    TableSelectionManager.prototype.onEvent = function (event) {
        switch (event.type.toLowerCase()) {
            case MOUSE_EVENTS.UP:
                this.stopTrackingStartClickLocation();
                break;
            case MOUSE_EVENTS.DOWN:
                this.clickedWithinTable(event);
                break;
            case MOUSE_EVENTS.MOVE:
                this.movedMouseOverTable(event);
                break;
            case MOUSE_EVENTS.LEAVE:
                this.mouseLeftTable(event);
                break;
            default:
                throw new Error("Got unknown event type");
        }
    };
    TableSelectionManager.prototype.deselect = function () {
        this.setSelectionStart();
    };
    TableSelectionManager.prototype.selectAllCells = function () {
        this.removeClickAwayListener();
        this.setSelectedCells(0, this.cellCount - 1);
        this.addClickAwayListener();
    };
    TableSelectionManager.prototype.moveToSelectedState = function (anchorKey, focusKey) {
        this.setSelectedCells(anchorKey, focusKey);
        this.addClickAwayListener();
    };
    TableSelectionManager.prototype.mouseLeftTable = function (event) {
        if (event.buttons === 1) {
            if (!this.isElementInToolbar(event.relatedTarget)) {
                this.selectAllCells();
            }
        }
    };
    TableSelectionManager.prototype.areAllCellsSelected = function () {
        var startToEnd = this.anchorCell == 0 && this.focusCell == this.cellCount - 1;
        var endToStart = this.focusCell == 0 && this.anchorCell == this.cellCount - 1;
        return startToEnd || endToStart;
    };
    TableSelectionManager.prototype.getSelectedRows = function (selectedCells, rows, cols) {
        var selectedRows = [];
        var currentRowSelected = true;
        var rowsChecked = 0;
        for (var i = 0; i < selectedCells.length; i++) {
            currentRowSelected = currentRowSelected && selectedCells[i];
            if ((i + 1) % cols == 0) {
                if (currentRowSelected) {
                    selectedRows.push(rowsChecked);
                }
                rowsChecked += 1;
                currentRowSelected = true;
            }
        }
        return selectedRows;
    };
    TableSelectionManager.prototype.getSelectedColumns = function (selectedCells, rows, cols) {
        var columnSelectedCellCounts = new Array(cols).fill(0);
        for (var i = 0; i < selectedCells.length; i++) {
            if (selectedCells[i]) {
                columnSelectedCellCounts[i % cols] += 1;
            }
        }
        var selectedColumns = [];
        for (var i = 0; i < columnSelectedCellCounts.length; i++) {
            if (columnSelectedCellCounts[i] == rows) {
                selectedColumns.push(i);
            }
        }
        return selectedColumns;
    };
    TableSelectionManager.prototype.stopTrackingStartClickLocation = function () {
        this.startClickLocation = undefined;
    };
    TableSelectionManager.prototype.clickedWithinTable = function (event) {
        if (!this.hasShiftButtonPressed(event)) {
            this.setSelectionStart(event);
        }
        else if (this.hasShiftButtonPressed(event) && this.hasSelectedCells()) {
            this.setSelectedCells(this.anchorCell, this.getCellIndexFromPoint(event.pageX, event.pageY));
        }
    };
    TableSelectionManager.prototype.movedMouseOverTable = function (event) {
        if (this.hasMouseButtonPressed(event)) {
            if (!!this.startClickLocation) {
                if (!this.hasSelectedCells()) {
                    this.processMovementAcrossBorders(event);
                }
                else {
                    this.updateSelectedCells(event);
                }
            }
            else {
                this.selectAllCells();
            }
        }
    };
    TableSelectionManager.prototype.setSelectionStart = function (event) {
        this.removeClickAwayListener();
        if (!!event) {
            this.startClickLocation = {
                x: event.pageX,
                y: event.pageY,
            };
            var newAnchorCell = this.getCellIndexFromPoint(event.pageX, event.pageY);
            this.setSelection(newAnchorCell, null);
        }
        else {
            this.setSelection(this.anchorCell, null);
        }
    };
    TableSelectionManager.prototype.hasMouseButtonPressed = function (event) {
        if (event.buttons == undefined) {
            return event.nativeEvent.which === 1;
        }
        return event.buttons === 1;
    };
    TableSelectionManager.prototype.hasShiftButtonPressed = function (event) {
        return event.shiftKey;
    };
    TableSelectionManager.prototype.hasSelectedAcrossCells = function (event) {
        var currCell = this.getCellIndexFromPoint(event.pageX, event.pageY);
        return currCell !== this.anchorCell;
    };
    TableSelectionManager.prototype.setSelectedCells = function (anchorCell, focusCell) {
        if (anchorCell == null) {
            this.setSelection(null, null);
        }
        else {
            if (focusCell != null) {
                if (anchorCell != this.anchorCell || focusCell != this.focusCell) {
                    this.setSelection(anchorCell, focusCell);
                }
            }
            else {
                var lastCell = this.cellCount - 1;
                this.setSelection(0, lastCell);
            }
        }
    };
    TableSelectionManager.prototype.getCellIndexFromPoint = function (x, y) {
        var e_1, _a;
        var xOffset = window.scrollX;
        var yOffset = window.scrollY;
        try {
            for (var _b = __values(this.elementToIndex), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), cell = _d[0], idx = _d[1];
                if (!cell) {
                    continue;
                }
                var extent = cell.getBoundingClientRect();
                var left = extent.left - 1 + xOffset;
                var right = extent.left + extent.width + xOffset;
                var top = extent.top - 1 + yOffset;
                var bottom = extent.top + extent.height + yOffset;
                if (left < x && x < right && top < y && y < bottom) {
                    return idx;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return -1;
    };
    TableSelectionManager.prototype.processMovementAcrossBorders = function (event) {
        if (this.hasSelectedAcrossCells(event)) {
            this.moveToSelectedState(this.anchorCell, this.getCellIndexFromPoint(event.pageX, event.pageY));
        }
    };
    TableSelectionManager.prototype.updateSelectedCells = function (event) {
        var currCell = this.getCellIndexFromPoint(event.pageX, event.pageY);
        if (currCell === this.anchorCell) {
            this.setSelectionStart();
        }
        else {
            this.setSelectedCells(this.anchorCell, currCell);
        }
    };
    TableSelectionManager.prototype.hasSelectedCells = function () {
        return this.anchorCell != null && this.focusCell != null;
    };
    Object.defineProperty(TableSelectionManager.prototype, "anchorCell", {
        get: function () {
            var props = this.tableProps();
            if (props != null && props.selection != null) {
                return props.selection.anchorCell;
            }
            else {
                return undefined;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TableSelectionManager.prototype, "focusCell", {
        get: function () {
            var props = this.tableProps();
            if (props != null && props.selection != null) {
                return props.selection.focusCell;
            }
            else {
                return undefined;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TableSelectionManager.prototype, "cellCount", {
        get: function () {
            return this.tableProps().rows * this.tableProps().columns;
        },
        enumerable: false,
        configurable: true
    });
    TableSelectionManager.prototype.removeClickAwayListener = function () {
        window.removeEventListener("mousedown", this.deselect);
    };
    TableSelectionManager.prototype.addClickAwayListener = function () {
        var _this = this;
        setTimeout(function () {
            window.addEventListener("mousedown", _this.deselect);
        });
    };
    TableSelectionManager.prototype.isElementInToolbar = function (elem) {
        var currElem = elem;
        while (currElem && !currElem.classList.contains("qwilr-editor")) {
            if (currElem.classList.contains("editor-main-toolbar")) {
                return true;
            }
            else {
                currElem = currElem.parentElement;
            }
        }
        return false;
    };
    return TableSelectionManager;
}());
exports.TableSelectionManager = TableSelectionManager;
